import { Typography } from '@mui/material';
import { _ } from '/@/locale';
import { capitalizeFirstLetter } from '/@/utils';

interface EmailSuccessStepProps {
    withInvitation: boolean;
    phoneOrEmail?: string;
    itemLabel: string;
}

function EmailSuccessStep({ withInvitation, phoneOrEmail, itemLabel }: EmailSuccessStepProps) {
    return (
        <Typography variant='body1' color='primary'>
            {withInvitation
                ? _('{{itemLabel}} se envió correctamente.', { itemLabel: capitalizeFirstLetter(itemLabel) })
                : phoneOrEmail
                  ? _('{{itemLabel}} fue enviada a {{phoneOrEmail}}.', {
                        itemLabel: capitalizeFirstLetter(itemLabel),
                        phoneOrEmail,
                    })
                  : _('{{itemLabel}} se envió correctamente.', { itemLabel: capitalizeFirstLetter(itemLabel) })}
        </Typography>
    );
}

export default EmailSuccessStep;
